export function tryFunctionOrLogError(f) {
    try {
        return f();
    }
    catch (e) {
        if (console.error) {
            console.error(e);
        }
    }
}
export function graphQLResultHasError(result) {
    return result.errors && result.errors.length;
}
//# sourceMappingURL=errorHandling.js.map


//////////////////
// WEBPACK FOOTER
// ../app_shared/~/apollo-utilities/lib/util/errorHandling.js
// module id = 584
// module chunks = 1